import api from './api';

export interface DashboardData {
  tiposServico: GraficoInfo[];
  diretorias: GraficoInfo[];
  areas: GraficoInfo[];
  contratosVigentesPorTipoServico: ContratosPorTipoServicos[];
  topContratosVigentesAndAtivos: ContratosTop[];
  vigenciaContrato: GraficoInfo[];
  saldoContrato: GraficoInfo[];
}

export interface GraficoInfo {
  nome: string;
  valor: number;
}

export interface ContratosPorTipoServicos {
  estatisticas: string;
  quantidadeContratos: number;
  contrato: number;
  medido: number;
  saldo: number;
  quantidade: number;
  deltaValor: number;
  mediaContrato: number;
  quantAditivo: number;
  deltaAdit: number;
}

export interface ContratosTop {
  informacoesContratuais: string;
  numeroContrato: number;
  ct: string;
  contrato: number;
  medido: number;
  saldo: number;
  inicio: string;
  termino: string;
  diasRestantes: number;
  quantidadeAditivo: number;
  area: string;
  gestor: string;
  tipoServico: string;
  contratoFormatado: string;
  medidoFormatado: string;
  saldoFormatado: string;
}

export interface ResponsavelMRN {
  id: string;
  nome: string;
}

export interface Filter {
  area?: string[];
  contratoStatus?: string[];
  vigencia?: number[];
  diretoria?: string[];
  fornecedor?: string[];
  responsaveis?: string[];
  tipoServico?: string[];
  dataInicial: string;
  dataFinal: string;
  contratos: string[];
  diasParaVencimento: number[];
  statusAutorizacaoMathing: string[];
  statusAtutorizacasoPagamento: string[];
  statusBoletimMedicao: string[];
}

export interface ContratoOption {
  id: string;
  descricaoContrato: string;
}

export const getDashboardData = (values: Filter = {}) => {
  return api.post<DashboardData>('contratos/dashboard', values, {
    disableNotification: 'true',
  });
};

export const getResponsaveisMRN = () => api.get<ResponsavelMRN[]>('usuarios/admContratosAndGestores');
export const getAllUserDashboard = () => api.get<ResponsavelMRN[]>('usuarios/getAllUserDashboard');
export const getAllDiasParaVencimento = () => api.get<ResponsavelMRN[]>('contratos/getAllDiasParaVencimento');
export const getAllSaldo = () => api.get<ResponsavelMRN[]>('contratos/getAllSaldo');
export const getContratoOption = () => api.get<ContratoOption[]>('contratos/getContratoOption');
export const getContratoOptionExcetoEncerrados = () =>
  api.get<ContratoOption[]>('contratos/getContratoOptionExcetoEncerrados');
export const getContratosAtivosOption = () => api.get<ContratoOption[]>('contratos/getContratosAtivosOptions');
export const getContratoOptionPorGestor = (id: string) =>
  api.get<ContratoOption[]>(`contratos/getContratoOptionPorGestor/${id}`);
export const getAllContratosDashboard = () => api.get<ContratoOption[]>('contratos/getAllContratosDashboard');

export const getResonsavelMRNOptions = () =>
  getResponsaveisMRN().then(responsavel =>
    (responsavel || []).map(item => ({ text: item.nome, value: item.id.toString() })),
  );

export const getAllUserDashboardOptions = () =>
  getAllUserDashboard().then(responsavel =>
    (responsavel || []).map(item => ({ text: item.nome, value: item.id.toString() })),
  );

export const getAllDiasParaVencimentoMRNOptions = () =>
  getAllDiasParaVencimento().then(responsavel =>
    (responsavel || []).map(item => ({ text: item.nome, value: item.id.toString() })),
  );

export const getAllSaldoMRNOptions = () =>
  getAllSaldo().then(responsavel => (responsavel || []).map(item => ({ text: item.nome, value: item.id.toString() })));

export const getAllContratoOptions = () =>
  getAllContratosDashboard().then(contrato =>
    (contrato || []).map(item => ({ text: item.descricaoContrato, value: item.id.toString() })),
  );
